var App = App || {};

App.Offers = (function ($) {
    'use strict';

    var offcanvas = $("#offcanvas-offers");
    var menuBack = offcanvas.find(".offers-offcanvas-header-back button");
    var controls = offcanvas.find(".offers-controls button");
    var promos = offcanvas.find(".offers-promos .promo-card");

    var sessionJson = sessionStorage.getItem("FirstCityCU_Offers");
    var sessionArray = sessionJson !== null ? JSON.parse(sessionJson) : [];

    function Init() {
        Offcanvas();
        Update();
        Interact();

        menuBack.on("click", function () {
            $("#offcanvas-nav-mobile").offcanvas("show");
        });
    }

    function Offcanvas() {
        offcanvas.on("show.bs.offcanvas", function () {
            const parent = promos.parent(".offers-promos");
            parent.ZagScrollAnimate({
                offset: 75,
                targets: [
                    { selector: ".promo-card", type: "animate__fadeInUp", stagger: 200 }
                ]
            });
        });

    }

    function Update() {

        controls.each(function () {
            var tagId = $(this).attr("data-tag");
            $(this).attr("aria-selected", sessionArray.includes(tagId));
        });

        if (sessionArray.length) {

            promos.each(function () {
                var tags = $(this).attr("data-tags");
                if (sessionArray.filter(value => tags.includes(value)).length) {
                    $(this).show();
                }
                else {
                    $(this).hide();
                }
            });
        }
        else {
            promos.show();
        }
    }

    function Interact() {
        controls.on("click", function () {

            var tagId = $(this).attr("data-tag");

            if (sessionArray.includes(tagId)) {
                sessionArray = sessionArray.filter(x => x != tagId);
            }
            else {
                sessionArray.push(tagId);
            }

            Update();

            sessionJson = JSON.stringify(sessionArray);
            sessionStorage.setItem("FirstCityCU_Offers", sessionJson);
        });
    }

    return {
        Init: Init
    };

})(jQuery);